// Page visibility over the Page Visibility API. Native sibling: visibility.native.ts (RN AppState).
// provenance: TanStack Query packages/query-core/src/focusManager.ts (MIT) — `visibilityState !== 'hidden'`
// read at call time plus a `visibilitychange` listener; https://github.com/TanStack/query

export function isVisible(): boolean {
  return document.visibilityState !== 'hidden'
}

/** Calls `listener` with the new visibility on every change; returns the unsubscribe. */
export function onVisibilityChange(listener: (visible: boolean) => void): () => void {
  const handler = () => listener(isVisible())
  document.addEventListener('visibilitychange', handler)
  return () => document.removeEventListener('visibilitychange', handler)
}
